<mat-drawer-container>
    <mat-drawer
      #snav
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [opened]="!mobileQuery.matches"
      [ngClass]="{ 'sidenav-collapsed': collapsedNav && !mobileQuery.matches }"
    >
      <div class="sidebar-brand">
        <img
          style="height: 47px; margin-left: 20px; margin-bottom: 1px"
          cImg
          fluid
          src="../../../assets/images/default-logo.png"
        />
        <h5 style="padding: 20px 10px 10px 10px">
          {{ collapsedNav && !mobileQuery.matches ? "" : "My Private Space" }}
        </h5>
      </div>
      <ul>
        <li [routerLink]="['/private-space/dashboard']" [routerLinkActive]="['active']">
          <div style="display: flex; align-items: center">
            <mat-icon
              >home</mat-icon
            >
            <div>{{ collapsedNav && !mobileQuery.matches ? "" : "Dashboard" }}</div>
          </div>
        </li>
        <li [routerLink]="['/private-space/view-properties']" [routerLinkActive]="['active']">
          <div style="display: flex; align-items: center">
            <mat-icon
              >widgets</mat-icon
            >
            <div>{{ collapsedNav && !mobileQuery.matches ? "" : "Properties" }}</div>
          </div>
        </li>
        <li [routerLink]="['/private-space/view-valuation-requests']" [routerLinkActive]="['active']">
          <div style="display: flex; align-items: center">
            <mat-icon
              >attach_money</mat-icon
            >
            <div>{{ collapsedNav && !mobileQuery.matches ? "" : "Valuation Requests" }}</div>
          </div>
        </li>
        <!-- <li [routerLink]="['/private-space/view-valuations']" [routerLinkActive]="['active']">
          <div style="display: flex; align-items: center">
            <mat-icon
              >attach_money</mat-icon
            >
            <div>{{ collapsedNav && !mobileQuery.matches ? "" : "Valuations" }}</div>
          </div>
        </li> -->
        <li [routerLink]="['/private-space/view-sporsorship-requests']" [routerLinkActive]="['active']">
          <div style="display: flex; align-items: center">
            <mat-icon
              >people_outline</mat-icon
            >
            <div>{{ collapsedNav && !mobileQuery.matches ? "" : "Sponsorship Requests" }}</div>
          </div>
        </li>
        <!-- <li [routerLink]="['/private-space/view-sporsorships']" [routerLinkActive]="['active']">
          <div style="display: flex; align-items: center">
            <mat-icon
              >attach_money</mat-icon
            >
            <div>{{ collapsedNav && !mobileQuery.matches ? "" : "Sponsorships" }}</div>
          </div>
        </li> -->
  
        <li (click)="exit()">
          <div style="display: flex; align-items: center">
            <mat-icon
              >exit_to_app</mat-icon
            >
            <div>{{ collapsedNav && !mobileQuery.matches ? "" : "Leave" }}</div>
          </div>
        </li>
      </ul>
    </mat-drawer>
    <mat-drawer-content
      [ngClass]="{ 'sidenav-collapsed': collapsedNav && !mobileQuery.matches }"
    >
      <mat-toolbar>
        <!-- <button mat-icon-button (click)="snav.toggle()"> -->
        <button
          mat-icon-button
          (click)="
            mobileQuery.matches ? snav.toggle() : (collapsedNav = !collapsedNav)
          "
        >
          <mat-icon>menu</mat-icon>
        </button>
      </mat-toolbar>
      <mat-card>
		<router-outlet></router-outlet>
      </mat-card>
    </mat-drawer-content>
  </mat-drawer-container>
